import React from 'react';
import Typo from '../typo';

const MatchCardCount = ({ matchcount }) => {
  return (
    <>
      <div className='si-matchCard__count'>
        <Typo component={'span'}>{matchcount}</Typo>
      </div>
    </>
  );
};

export default MatchCardCount;
